module.exports = __webpack_public_path__ + "/login_ui/img/ls-0370b3930c42ae5a2172cca56a3f95ec.svg";